import { useEffect, useState } from 'react';
import './App.scss'
import Api from './axios'

function App() {
  const [showCartDrawer, setShowCartDrawer] = useState(false)
  const [width, setWidth] = useState('0px')
  const [opacity, setOpacity] = useState('0')
  const [items, setItems] = useState([])
  const [subtotal, setSubtotal] = useState('')
  const [discount, setDiscount] = useState('')
  const [total, setTotal] = useState('')

  window.setShowCartDrawer = setShowCartDrawer

  const fetchItems = async () => {
    Api.get('/cart/drawer').then((res) => {
      if (!res) return
      setItems(res.data.items)
      setSubtotal(res.data.subtotal)
      setDiscount(res.data.discount)
      setTotal(res.data.total)
    })
  }

  const removeItem = async (id) => {
    window.$.fn.msg.confirm('Atenção!', 'Deseja realmente remover este item do carrinho?', () => {
      Api.get('/cart/remove2/' + id).then((res) => {
        if (!res) return

        window.$('#myModal').modal('hide')
        fetchItems()
        window.updateQty()
      })
    });
  }

  const navigateTo = (url) => {
    document.location.href = url
  }

  useEffect(() => {
    if (showCartDrawer) {
      fetchItems()
      setWidth('400px')
      setOpacity('1')
    } else {
      setWidth('0px')
      setOpacity('0')
    }
  }, [showCartDrawer])

  return (
    <>
      <div className='cart-drawer-shadow' style={{ opacity: opacity, display: opacity === '0' ? 'none' : 'block' }}></div>
      <div className={'cart-drawer' + (!showCartDrawer ? ' hide' : '')} style={{ width: width, opacity: opacity }}>
        {/*<div className='btn-close' onClick={_ => setShowCartDrawer(false)}><i className='fa fa-times fa-2x'></i></div>*/}
        <h2>Itens no Carrinho</h2>
        <hr className='line' />
        <div className='list-items-cart'>
          {items.map((item, idx) => (
            <div className={'item-cart d-flex' + (idx > 0 ? ' mt-3' : '')} key={idx}>
              <div className='btn-remove' onClick={_ => removeItem(item.productId)}><i class="fa fa-times-circle"></i></div>
              <div className='item-cart-img'>
                <img src={item.photo} alt={item.productName} className='img-fluid' />
              </div>
              <div className='item-cart-info'>
                <h3 onClick={_ => navigateTo(item.url)}>{item.productName}</h3>
                <div className='box-qty-price'>
                  <span className='qty'>{item.quantity} X </span>
                  <span className='price'>R$ {item.price}</span>
                </div>
              </div>
            </div>
          ))}
          {items.length === 0 && <p>Nenhum item no carrinho</p>}
        </div>
        {items.length > 0 && (
          <>
            <hr className='line' />
            <div className='totals'>
              <div className='item subtotal d-flex'>
                <div className='title'>{window.translate.totalsSubtotalTitle}:</div>
                <div className='value flex-fill'>{subtotal}</div>
              </div>
              {discount && (
                <div className='item discount d-flex'>
                  <div className='title'>{window.translate.totalsDiscountTitle}:</div>
                  <div className='value flex-fill'>{discount}</div>
                </div>
              )}
              <div className='item total d-flex'>
                <div className='title'>{window.translate.headerCartTotalLabel}:</div>
                <div className='value flex-fill'>{total}</div>
              </div>
            </div>
          </>
        )}
        <div className='space-30'></div>
        <button type='button' className="btn btn-block btn-secondary" onClick={_ => setShowCartDrawer(false)}>Continuar comprando</button>
        {items.length > 0 && (
          <a style={{ marginTop: '16px' }} className="btn btn-block btn-primary" href={window.appBaseUrl + '/cart'}>{window.translate.headerCartCheckoutButton}</a>
        )}
      </div>
    </>
  );
}

export default App